import { queryKeys } from "@/constants/queryKeyFactory";
import { ApiResponse } from "@/interfaces/api.interface";
import { FileWithPreview, IRequestLogs } from "@/interfaces/request.interface";
import { api } from "@/lib/api";
import { queryClient } from "@/lib/queryClient";
import ToastService from "@/utils/toast";
import { BaseService } from "./base.service";

export class RequestService extends BaseService {
  constructor() {
    super("Request");
  }

  async uploadAttachments(requestId: string, files: FileWithPreview[]) {
    try {
      const formData = new FormData();
      formData.append("RequestId", requestId);
      // Here's the important part: Use the uniqueFile property for each file
      files.forEach((file) => {
        // If we have a uniqueFile (renamed file), use that - otherwise fallback to original file
        const fileToUpload = file.uniqueFile || file;
        formData.append("Attachments", fileToUpload);
      });

      const res: any = await api.post(`${process.env.REACT_APP_BASE_URL}/api/Request/upload-attachments`, formData);

      if (res.ok) {
        if (res.data) {
          return { data: res.data, error: null };
        }
        return { data: null, error: res.data };
      }
      return { data: null, error: res.data };
    } catch (error) {
      return { data: null, error: error };
    } finally {
    }
  }

  async fetchLogsByArea(areaId: string): Promise<ApiResponse<IRequestLogs[]>> {
    try {
      const res: any = await api.get(`${process.env.REACT_APP_BASE_URL}/api/Request/request-logs/${areaId}`);

      if (res.ok) {
        return {
          data: res.data,
          error: null,
        };
      }

      throw new Error(res.data?.message || "An error occurred while fetching areas");
    } catch (error) {
      return {
        data: null,
        error: {
          message: (error as string) || "An error occurred while fetching areas",
        },
      };
    }
  }

  async reassignRejectedAAR(requestId: string): Promise<ApiResponse<void>> {
    const res: any = await api.put(`/Request/reassign-rejected-aar/${requestId}`);

    if (res.data?.statusCode === 400 || res.data?.message) {
      ToastService.error(res.data.message);
      throw {
        response: {
          data: res.data,
          status: res.data.statusCode,
        },
      };
    }
    ToastService.success("AAR reassigned successfully.");
    queryClient.invalidateQueries({
      queryKey: queryKeys.tasks.root,
      refetchType: "active",
    });
    queryClient.invalidateQueries({
      queryKey: queryKeys.request.root,
    });
    queryClient.invalidateQueries({
      queryKey: queryKeys.levels.root,
    });
    queryClient.invalidateQueries({
      queryKey: queryKeys.tasks.request(requestId),
    });
    return { data: res.data as unknown as void, error: null };
  }
}

export const reqSvc = new RequestService();
